import { styled } from '@mui/material';

export const WrapperButtons = styled('div')(() => ({
  display: 'flex',
}));
